export const containerStyle = {
    padding: "0.7rem 1.5rem 1.5rem 1.5rem",
    overflow: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
        display: 'none'
    }
};

export const headerBarStyle={
    display:'flex',
    flexDirection: 'row',
    // justifyContent: 'space-between',
    width: '95%',
    // height: '100%',
    // border: '1px solid',
    padding: '0.3rem'
}

export const headerBarStyleMobile={
    display:'flex',
    flexDirection: 'row',
    alignItems: 'space-between',
    // justifyContent: 'space-between',
    width: '95%',
    padding: '0.3rem'
}

export const ddBoxStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
}
export const searchBarStyle = {
    width: '30%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '0rem 0rem 0rem 0.5rem'
}

export const searchBarStyleMobile = {
    //width: '70%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
}

export const bodyContainer = {
    padding: '1rem 0rem 0.2rem 0rem',
    overflow: 'auto',
    height: '63vh',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
        display: 'none'
    }
}

export const bodyContainerMobile = {
    padding: '1rem 0rem 0.2rem 0rem',
    overflow: 'auto',
    height: '72vh',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
        display: 'none'
    }
}
